export { default as AttachmentIconViewBase, IconSize } from './components/AttachmentIconViewBase';
export { default as AttachmentDocInfoViewBase } from './components/AttachmentDocInfoViewBase';
